import { motion } from 'framer-motion';

export default function About() {
    return (
        <section id="about" className="py-8 bg-white dark:bg-surface-dark relative w-full">
            <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid md:grid-cols-2 gap-8">

                    <motion.div
                        initial={{ opacity: 0, x: -30 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.8 }}
                    >
                        <h2 className="text-2xl font-display font-bold text-gray-900 dark:text-white mb-6 border-l-4 border-primary pl-4">About Me</h2>
                        <div className="prose prose-blue dark:prose-invert text-gray-600 dark:text-gray-300 leading-relaxed">
                            <p className="mb-4">
                                Dr. Priyanka Katiyar is an Associate Professor at <strong className="text-primary dark:text-blue-400">Shiv Nadar University</strong> and holds a Ph.D. in Chemical Engineering from <strong className="text-primary dark:text-blue-400">IIT Roorkee</strong>.
                            </p>
                            <p>
                                Her research mainly focuses on <span className="bg-blue-50 dark:bg-blue-900/30 px-1 rounded text-primary dark:text-blue-300 font-medium">Biofuels</span>, <span className="bg-blue-50 dark:bg-blue-900/30 px-1 rounded text-primary dark:text-blue-300 font-medium">Membrane Separation</span>, <span className="bg-blue-50 dark:bg-blue-900/30 px-1 rounded text-primary dark:text-blue-300 font-medium">Energy and Environment Sustainability</span>, <span className="bg-blue-50 dark:bg-blue-900/30 px-1 rounded text-primary dark:text-blue-300 font-medium">Supercritical Fluid Extraction</span> and Catalysis.
                            </p>
                            <p className="mt-4 text-sm text-gray-500">
                                She is dedicated to developing sustainable solutions for industrial waste management and clean energy production through innovative chemical engineering processes.
                            </p>
                        </div>
                    </motion.div>

                    <motion.div
                        className="bg-gray-50 dark:bg-gray-800/50 p-6 rounded-2xl border border-gray-100 dark:border-gray-700"
                        initial={{ opacity: 0, x: 30 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.8, delay: 0.2 }}
                    >
                        <h2 className="text-xl font-display font-bold text-gray-900 dark:text-white mb-6 flex items-center">
                            <span className="material-icons mr-2 text-primary dark:text-blue-400">school</span> Education & Experience
                        </h2>

                        <div className="space-y-6 border-l-2 border-gray-200 dark:border-gray-600 ml-3 pl-6 relative">
                            <div className="relative">
                                <span className="absolute -left-[31px] top-1 h-4 w-4 rounded-full bg-primary border-4 border-white dark:border-gray-800"></span>
                                <h3 className="font-bold text-gray-900 dark:text-white">Associate Professor</h3>
                                <p className="text-sm text-primary dark:text-blue-400">Shiv Nadar University</p>
                                <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">2026 - Present</p>
                            </div>
                            <div className="relative">
                                <span className="absolute -left-[31px] top-1 h-4 w-4 rounded-full bg-gray-400 border-4 border-white dark:border-gray-800"></span>
                                <h3 className="font-bold text-gray-900 dark:text-white">Assistant Professor</h3>
                                <p className="text-sm text-gray-600 dark:text-gray-300">Shiv Nadar University</p>
                                <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">2018 - 2025</p>
                            </div>
                            <div className="relative">
                                <span className="absolute -left-[31px] top-1 h-4 w-4 rounded-full bg-gray-400 border-4 border-white dark:border-gray-800"></span>
                                <h3 className="font-bold text-gray-900 dark:text-white">Ph.D. in Chemical Engineering</h3>
                                <p className="text-sm text-gray-600 dark:text-gray-300">IIT Roorkee</p>
                                <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">2013 - 2018</p>
                            </div>
                            <div className="relative">
                                <span className="absolute -left-[31px] top-1 h-4 w-4 rounded-full bg-gray-400 border-4 border-white dark:border-gray-800"></span>
                                <h3 className="font-bold text-gray-900 dark:text-white">M.Tech in Chemical Engineering</h3>
                                <p className="text-sm text-gray-600 dark:text-gray-300">IIT Roorkee</p>
                                <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">2011 - 2013</p>
                            </div>
                            <div className="relative">
                                <span className="absolute -left-[31px] top-1 h-4 w-4 rounded-full bg-gray-400 border-4 border-white dark:border-gray-800"></span>
                                <h3 className="font-bold text-gray-900 dark:text-white">B.Tech in Chemical Engineering</h3>
                                <p className="text-sm text-gray-600 dark:text-gray-300">UIET, CSJM University Kanpur</p>
                                <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">2007 - 2011</p>
                            </div>
                        </div>
                    </motion.div>

                </div>
            </div>
        </section>
    );
}
